import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';
import { apiFetch } from './api';

/**
 * Returns a fetch wrapper that attaches the Auth0 access token.
 */
export function useAuthorizedFetch() {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  return useCallback(
    async <T>(path: string, options: RequestInit = {}): Promise<T> => {
      if (!isAuthenticated) {
        throw new Error('Not authenticated');
      }
      const token = await getAccessTokenSilently();
      return apiFetch<T>(path, { ...options, token });
    },
    [getAccessTokenSilently, isAuthenticated],
  );
}
